import { useBucket } from '@mc/experiments-react'
import { usePromotion } from '@mc/promo-utils'
import { PROMO_BANNER_COUNTDOWN_FLAG_NAME } from '../constants'
import { useCountdown } from './useCountdown'

/**
 * Eligible = in the experiment population: an active promotion whose end instant falls inside the
 * countdown window. Gating on the window rather than on every banner mount keeps the sample from
 * being diluted by visitors who could never have seen the treatment. `isGift` is forwarded so a
 * gift page during a non-gift-eligible promo resolves the same way the banner itself does.
 */
export const useExperiment = ({
  isGift = false,
}: { isGift?: boolean } = {}) => {
  const { isPromotionOn, variables } = usePromotion({ isGift })
  const bucket = useBucket(PROMO_BANNER_COUNTDOWN_FLAG_NAME)
  const remainingMs = useCountdown(variables.promo_end_at)

  const isEligible = isPromotionOn && remainingMs !== null

  return {
    isEligible,
    isVariant: !!(isEligible && bucket?.startsWith('variant')),
    remainingMs,
  }
}
